import { render, staticRenderFns } from "./RatingDashboardStatsCard.vue?vue&type=template&id=0e870181&"
import script from "./RatingDashboardStatsCard.vue?vue&type=script&lang=js&"
export * from "./RatingDashboardStatsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports